import { browserPdfOutput, type DefectsSource } from '@felix/ui';
import { officeApi } from './api.js';

/**
 * Ofiste arıza DM-17 (ADR 0060): filo listesi ve kayıt salt okunur (arıza gemide yazılır, mimari
 * belge §8). Ofis Part C yönetim önlemini ve yorumu kendi değiştirilemez notuyla yazar, yönetim
 * adımına parolayla karar verir; ekler ofis adresinden açılır.
 */
export const officeDefectsSource: DefectsSource = {
  scope: 'office',
  list: () => officeApi.fleetDefects(),
  detail: (id) => officeApi.defectDetail(id),
  attachments: (id) => officeApi.pmsAttachments(id, 'defect'),
  attachmentUrl: (id) => `/api/office/attachments/${encodeURIComponent(id)}`,
  brand: async () => {
    try {
      const { branding } = await officeApi.branding();
      return branding?.name ? { name: branding.name, logo: branding.logo ?? null } : null;
    } catch {
      return null;
    }
  },
  pdf: browserPdfOutput(),
  office: {
    note: (id, input) => officeApi.defectNote(id, input),
    decide: async (id, input) =>
      (
        await officeApi.decideDefectReport(id, {
          contentHash: input.contentHash,
          submissionId: input.submissionId,
          step: input.step,
          decision: input.decision,
          ...(input.reason ? { reason: input.reason } : {}),
          ...(input.password ? { password: input.password } : {}),
        })
      ).defect,
  },
};
